module.exports = __webpack_public_path__ + "img/loader-laadpaal.935d4776.gif";